import { signOut } from "next-auth/react";
import { Confirm } from "./confirm";
import { useStateStore } from "@/context/stateStore";

export const SignOutHook = () => {
    
    const confirmSignOut = () => {
        Confirm(
            'Confirm Sign Out',
            'Are you sure you want to sign out? Any unsaved changes will be lost.',
            async () => {
                useStateStore.getState().setGlobalLoading(true);
                await signOut({ callbackUrl: '/' });
            },
            'Sign out',
            'Cancelled Sign out'
        );
    }

    return { confirmSignOut };
}